<template>
  <v-snackbar v-model="open" class="snackbar ml-8" :color="snackbarColor" :timeout="timeout" left>
    {{ message }}
    <template v-slot:action="{ attrs }">
      <v-btn icon small color="white" v-bind="attrs" class="close-btn" @click="closeSnackbar">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  },
  watch: {
    open(value) {
      if (!value) {
        this.closeSnackbar()
      }
    }
  }
}
</script>
<style lang="scss">
.snackbar {
  font-family: 'Lato', sans-serif;
  z-index: 999999 !important;
  :deep(.close-btn) {
    margin-right: 16px !important;
  }
}
</style>
